import { Survey } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';
import useGetIntegrationEditFormData from 'v2/core/repository/edge-server/integrations/editIntegrations/useGetIntegrationEditFormData';

export function useFetchSurveyMonkeySurveys(integrationID: UUID) {
  const { data, status } = useGetIntegrationEditFormData({
    integrationID,
  });

  return {
    data:
      data?.surveyMonkey?.surveys?.filter((survey): survey is Survey =>
        Boolean(survey),
      ) ?? [],
    status,
  };
}
